import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceManagement-deviceHealthScripts'

export const intuneDeviceHealthScriptsApi = createApi({
  reducerPath: 'intuneDeviceHealthScripts',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getDeviceHealthScripts: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
    }),
    getDeviceHealthScriptById: builder.query({
      query: ({ itemId, customerId }) => ({
        url: `${url}/${itemId}`,
        params: { customerId },
      }),
    }),
    createDeviceHealthScript: builder.mutation({
      query: ({ customerId, userId, hubTaskSource, payload }) => ({
        url,
        body: payload,
        params: { customerId, userId, source: hubTaskSource },
        method: 'POST',
      }),
    }),
    deleteDeviceHealthScript: builder.mutation({
      query: ({ policyId, customerId, userId }) => ({
        url,
        params: { customerId, userId, policyId },
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useGetDeviceHealthScriptsQuery,
  useLazyGetDeviceHealthScriptsQuery,
  useGetDeviceHealthScriptByIdQuery,
  useLazyGetDeviceHealthScriptByIdQuery,
  useCreateDeviceHealthScriptMutation,
  useDeleteDeviceHealthScriptMutation,
} = intuneDeviceHealthScriptsApi

export const useGetDeviceHealthScripts = () => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDeviceHealthScriptsQuery(customerId)
}

export const useGetDeviceHealthScriptById = ({ itemId }, options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDeviceHealthScriptByIdQuery({ itemId, customerId }, { ...options, skip: options.skip || !itemId })
}
